import React, { useState, useCallback, useEffect } from 'react'
import { Recorder } from 'react-voice-recorder';
import 'react-voice-recorder/dist/index.css';
import { Form } from "react-bootstrap";
import { useDropzone } from "react-dropzone";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Multiselect from 'multiselect-react-dropdown';
import CustomInput from './CustomInput';
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DatePicker from "react-multi-date-picker";


//functions of Recorder
export default function RecordField({ audioHandler, name }) {
    const [audioDetails, setAudioDetails] = useState({ url: null, blob: null, chunks: null, duration: { h: 0, m: 0, s: 0 } });
    
    const handleAudioStop = (data) => {
        setAudioDetails({ audioDetails: data });
        createDownloadLink(name,data.blob)
    }
    
    const createDownloadLink = (name,blob) => {

        var url = URL.createObjectURL(blob);
        var xhr = new XMLHttpRequest();
        xhr.responseType = 'blob';
        xhr.onload = function () {
            var recoveredBlob = xhr.response;
            var reader = new FileReader();

            reader.onload = function () { 
                audioHandler( name,reader.result);

                return reader.result;

            };

            reader.readAsDataURL(recoveredBlob);
        };

        xhr.open('GET', url);
        xhr.send();
    };

    const handleAudioUpload = (file) => {
        // console.log(file);
    }

    const handleCountDown = (data) => {
        //console.log(data);
    }

    const handleReset = () => {
        setAudioDetails({ url: null, blob: null, chunks: null, duration: { h: 0, m: 0, s: 0 } });
    }

    return (
        <div>
            <Recorder
                record={true}
                // title={"New recording"}
                audioURL={audioDetails.url}
                showUIAudio
                handleAudioStop={(data) => handleAudioStop(data)}
                handleAudioUpload={(data) => handleAudioUpload(data)}
                handleCountDown={(data) => handleCountDown(data)}
                handleReset={() => handleReset()}
                mimeTypeToUseWhenRecording={`audio/webm`} // For specific mimetype.
            />
        </div>
    )
}



//functions of Checkbox
export const CheckboxField = ({ name, Setchange, List }) => {
    const [checked, setChecked] = useState([]);

    const handleCheck = (event) => {

        var updatedList = [...checked];
        if (event.target.checked) {
            updatedList = [...checked, event.target.value];
        } else {
            updatedList.splice(checked.indexOf(event.target.value), 1);
        }
        setChecked(updatedList);
        Setchange(updatedList, name);

    };

    return (
        <div>
            <Form.Group controlId="formBasicCheckbox">
                {List.map((item, index) => (
                    <Form.Check
                        required 
                        key={index}
                        inline
                        value={item.id}
                        className="rgc-form-check-input"
                        id={item.id}
                        label={item.value}
                        onChange={handleCheck}
                    />
                ))}
            </Form.Group>
        </div>
    )
}

//functions of Radio
export const RadioField = ({ name, radioHandler1, List }) => {
    const [checked, setChecked] = useState();
    const [isRadio, setIsRadio] = useState();
    const handleChange = (val, index) => {
        setIsRadio(val);
        setChecked(index);
        radioHandler1(val, name)
   };

    return (
        <div>
            <Form.Group >
                {List.map((item, i) => (
                    <Form.Check
                        required
                        inline
                        label={item.value}
                        key={item.id}
                        type="radio"
                        value={item.id}
                        id={item.id}
                        checked={checked === i}
                        onChange={(event) => handleChange(event.target.value, i)}
                    />
                ))}
            </Form.Group>
        </div>
    )
}

//function of Images
export const ImagesField = ({ name, imageHandler }) => {
    const [imageSize, setImageSize] = useState(0);
    const [image, setImage] = useState();

    useEffect(() => {
        imageHandler(image, name)
    }, [image])


    //part of uploade image
    const onDrop = useCallback((acceptedFiles) => {
        acceptedFiles.forEach((file) => {
            setImageSize(Math.round(file.size / 1024));
            const reader = new FileReader();
            reader.onload = () => {
                if (file.size > 11000000) {
                    toast.error("عکس نباید بیشتر از 11 مگابایت باشد", {
                        position: 'top-center',
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    return;
                } else {
                    const img_src = reader.result;
                    setImage(img_src);
                }
            };
            reader.readAsDataURL(file);
        });

    }, []);

    const { getRootProps, getInputProps } = useDropzone({ onDrop });

    //remove image
    const removeImage = () => {
        setImage(null);
        setImageSize(0);
    };

    return (
        <div className='rgc-dropzone'>
          <p>حجم عکس باید کمتر از 10 مگابایت باشد</p>
            {!image ? (
                <div className="col-12">
                    <div className="dropzone mt-0" id="myDropzone2">
                        <div {...getRootProps()} className="rgc-dropzone-icon">
                            <input {...getInputProps()} multiple={true} />
                            <button className="dz-button" type="button">
                                <i className="fas fa-plus-square"></i>
                                <span> انتخاب تصویر</span>
                            </button>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="col-12">
                    <div
                        className="dropzone mt-0 drop-custom"
                        id="myDropzone2"
                    >
                        <div className="imgbox__container">
                            <img src={image} className="imgbox__img" alt="" />
                            <p
                                className="imgbox__size"
                                onClick={() => removeImage()}
                            >
                                {imageSize + " KB"}{" "}
                                <i className="fa fa-times-circle"></i>
                            </p>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

//function of Multiselect
export const MultiselectField = ({ name, multiselectHandler, List }) => {
    const [select, setSelect] = useState([]);
    const [selectId, setSelectId] = useState([]);


    const multiHandler = (event) => {
        const filtered = event.reduce((a, o) => (o.value && a.push(o.id), a), [])
        console.log(filtered)
        console.log(event)
        setSelect(event)
        multiselectHandler(filtered, name)
    }

    return (
        <div>
            <Multiselect
                displayValue="value"
                onKeyPressFn={function noRefCheck() { }}
                onRemove={function noRefCheck() { }}
                onSearch={function noRefCheck() { }}
                onSelect={(event) => multiHandler(event)} // Function will trigger on select event
                options={List.map((item, index) => (
                    {
                        id: item.id,
                        value: item.value
                    }
                ))
                }
            />
        </div>
    )
}

//function of Number
export const NumberField = ({ name, numberHandler }) => {
    const [number, setNumber] = useState()

    const handleChange = (val) => {
        setNumber(val);
        numberHandler(val, name);
    }

    return (
        <div>
            <CustomInput
                //   icon={"fa fa-pen"}
                label={"عدد"}
                type={"number"}
                value={number}
                placeholder={"عدد"}
                onChange={(event) => handleChange(event.target.value)}
            //   onKeyDown1={handleEnter}
            />
        </div>
    )
}

//function of Section
export const SectionFields = ({ name, sectionHandler1, title }) => {

    useEffect(() => {
        sectionHandler1(title, name)
    }, [])

    return (
        <div>
            <section className='rgc-section'>
                <h2>{title}</h2>
                <hr />
                <p>
                    میز خدمت به عنوان تنها نقطه تماس بین ارائه‌کننده خدمات و کاربران تعریف شده است.
                    یک میز خدمت معمولی، رویدادها و سفارشات را مدیریت می‌کند و امکان ارتباط با کاربران را فراهم می‌کند.
                    اگر بخواهیم ساده‌تر بگوییم که میز خدمت چیست ، باید بگوییم میز خدمت یک مرکز ارتباطی است که در آن مشتریان
                </p>
            </section>
        </div>
    )
}

//function of DateFields
export const DateField = ({ name, dateHandler }) => {
    const [date, setDate] = useState(new Date());
    useEffect(() => {
        dateHandler(typeof date !== 'string' ? new Date(date).toLocaleDateString("fa-IR") : date, name)
    }, [])

    return (
        <div>
            <DatePicker

                placeholder="تاریخ"
                calendar={persian}
                locale={persian_fa}
                calendarPosition="bottom-right"
                value={date}
                onChange={setDate}
            />
        </div>
    )
}

//function of TextFields
export const TextField = ({ name, textHandler }) => {
    const [text, setText] = useState();

    const handleChange = (val) => {
        setText(val);
        textHandler(val, name);
    }

    return (
        <div>
            <CustomInput
                icon={"fa fa-pen"}
                label={"متن"}
                type={"text"}
                value={text}
                placeholder={"متن"}
                onChange={(event) => handleChange(event.target.value)}
            //   onKeyDown1={handleEnter}
            />
        </div>
    )
}














